import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';
import { CAPTCHA_ERROR_MESSAGES } from '../constants/recaptcha.config';

@Injectable({
  providedIn: 'root',
})
export class ShowMessageService {
  private $primeMessage = inject(MessageService);

  private $transloco = inject(TranslocoService);

  successMsg(message = 'successfully_saved') {
    this.$primeMessage.add({
      severity: 'success',
      summary: this.$transloco.translate('Success'),
      detail: this.$transloco.translate(message),
      life: 3000,
    });
  }

  errorMsg(message = 'somenthing_went_wrong') {
    let detail = '';
    if (message && CAPTCHA_ERROR_MESSAGES[message]) {
      const activeLang = this.$transloco.getActiveLang() || 'uz';
      const translated = this.$transloco.translate(message);
      if (translated && translated !== message) {
        detail = translated;
      } else {
        const langMap = CAPTCHA_ERROR_MESSAGES[message];
        detail = langMap[activeLang] || langMap['uz'] || langMap['en'];
      }
    } else {
      detail = this.$transloco.translate(message);
    }

    this.$primeMessage.add({
      severity: 'error',
      summary: this.$transloco.translate('Error'),
      detail,
    });
  }

  warning(message: string) {
    this.$primeMessage.add({
      severity: 'warn',
      summary: this.$transloco.translate('Warning'),
      detail: this.$transloco.translate(message),
    });
  }
}
